/**
 * Albanian catalog (Latin) for the Phase 2 `MessageId` set — Agent 9, batch 2.
 *
 * `dir: 'ltr'`. Native-grade Albanian at a mathematician's register. **Warrant → «Arsyetim»**
 * (justification — flagged). W/M grades stay Latin (`::numbering-system/latn`). CLDR cardinal
 * categories are one / other, so `frameActive` declares exactly those (plus an explicit `=0`).
 * Per INV-STABLE-ID a wrong translation is a presentation concern only — verdicts stay fixed.
 */
import { P2 } from '../message-ids-phase2.js';
export const SQ_CATALOG = {
    locale: 'sq',
    dir: 'ltr',
    messages: {
        [P2.inquiryTitle]: 'Hetim',
        [P2.sectionClaims]: 'Pohime',
        [P2.sectionIntegrity]: 'Integriteti',
        [P2.axisWarrantLabel]: 'Arsyetim',
        [P2.axisWarrantValue]: 'W{w, number, ::numbering-system/latn}',
        [P2.axisEmpiricalLabel]: 'Empirik',
        [P2.axisEmpiricalValue]: '{kind, select, defn {Përkufizim} interp {Interpretim} testable {I testueshëm} tested {I testuar} refuted {I përgënjeshtruar} program {Program kërkimor} philos {Filozofik} other {I panjohur}}',
        [P2.axisModalLabel]: 'Modal',
        [P2.axisModalValue]: 'M{m, number, ::numbering-system/latn}',
        [P2.axisKidSummary]: 'Niveli i forcës {w, number, ::numbering-system/latn}',
        [P2.stateExplorable]: 'I eksplorueshëm',
        [P2.stateRefuted]: 'I përgënjeshtruar',
        [P2.stateOutside]: 'Jashtë fushës',
        [P2.verdictConflict]: 'Në konflikt me {constraints}',
        [P2.verdictOutside]: 'Kërkon {missing}',
        [P2.lossRegisterPlain]: 'I thjeshtuar në gjuhë të zakonshme — një pjesë e saktësisë lihet jashtë.',
        [P2.lossRegisterKid]: 'I thjeshtuar për lexuesit e rinj — shumë detaje lihen jashtë.',
        [P2.lossProfileDetail]: 'Profili i plotë Arsyetim / Empirik / Modal përmblidhet këtu.',
        [P2.lossConflictDetail]: 'Detajet e konfliktit janë shkurtuar në këtë pamje.',
        [P2.laneVerified]: 'I verifikuar',
        [P2.laneUnverified]: 'I paverifikuar',
        [P2.laneConflict]: 'Konflikt i provuar',
        [P2.constraintLogic]: 'Logjika',
        [P2.constraintLightBends]: 'Drita përkulet në një fushë gravitacionale',
        [P2.constraintParallelPostulate]: 'Postulati i paraleleve',
        [P2.claimScalarGravity]: 'Teoria skalare e gravitetit',
        [P2.claimNonEuclidean]: 'Gjeometria joeuklidiane',
        [P2.claimSubstrateSr]: 'Interpretimi me substrat i relativitetit special',
        [P2.edgeExtObservation]: 'Vëzhgim i jashtëm',
        [P2.edgeResourceSample]: 'Burim llogaritës i përbashkët',
        [P2.edgeHeuristicSample]: 'Udhëzim heuristik',
        [P2.edgeSharedSample]: 'Themel i përbashkët',
        // --- Phase 2 view-chrome ---
        [P2.sectionConstraints]: 'Kufizime',
        [P2.sectionEdges]: 'Brinjë',
        [P2.sectionFrame]: 'Korniza',
        [P2.sectionExposure]: 'Ekspozim',
        [P2.statusAdoptedFormal]: 'Miratuar (formal)',
        [P2.statusAdoptedInterpretive]: 'Miratuar (interpretues)',
        [P2.statusSuspended]: 'Pezulluar',
        [P2.edgeEffectConstraint]: 'Përbën një kufizim (mund të përgënjeshtrojë)',
        [P2.edgeEffectResource]: 'Burim — pa efekt te verdiktet',
        [P2.edgeEffectHeuristic]: 'Heuristikë — pa efekt te verdiktet',
        [P2.edgeEffectShared]: 'Themel i përbashkët — pa efekt te verdiktet',
        [P2.frameActive]: '{count, plural, =0 {Asnjë kufizim aktiv} one {# kufizim aktiv} other {# kufizime aktive}}',
        [P2.exposureNone]: 'Pa varësi interpretuese',
        [P2.exposureDep]: 'Varet nga {id}',
        [P2.laneTrackMachine]: 'Makinë',
        [P2.laneTrackExpert]: 'Ekspert',
        [P2.laneTrackCommunity]: 'Komuniteti',
        [P2.expertAudited]: 'I audituar',
        [P2.expertInProgress]: 'Në vazhdim',
        [P2.expertNotReviewed]: 'I pashqyrtuar',
        [P2.communityFlags]: 'Ka shenjime',
        [P2.communityNone]: 'Pa shenjime',
        [P2.controlChallenge]: 'Kundërshto',
        [P2.controlActivate]: 'Aktivizo',
        [P2.controlMakeInterpretive]: 'Bëje interpretues',
        [P2.controlImportEdge]: 'Importo brinjën',
        [P2.controlPromote]: 'Promovo',
        [P2.controlUndo]: 'Zhbëj',
        [P2.controlRedo]: 'Ribëj',
        [P2.controlRegister]: 'Regjistro',
        [P2.promoteRejected]: 'Promovimi u refuzua',
        [P2.promoteAccepted]: 'Promovimi u pranua',
        [P2.promoteReasonRefutationTerminal]: 'Një provë nuk mund të shërojë një përgënjeshtrim.',
        [P2.promoteReasonKeystone]: 'Një promovim themelor kërkon mbështetje empirike.',
        [P2.promoteReasonEmpiricalNotFixed]: 'Lloji empirik nuk është fiksuar.',
        [P2.promoteReasonModalNotFixed]: 'Shkalla modale nuk është fiksuar.',
        [P2.promoteReasonWarrantNotImproved]: 'Shkalla e arsyetimit nuk është përmirësuar.',
        [P2.evidenceComputation]: "{engine} computed {op} = {result} under {config}",
        [P2.lossNumericRounding]: "Result rounded to {dp} decimal places",
    },
};
//# sourceMappingURL=sq.js.map